
import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOnlineBookingApi } from 'shell';
import { userDataSet } from 'store/userData';
import { appointmentDataSet, successStepSet, scriptMessagesSet } from 'store/steps';
import { popupActiveSet } from 'store/general';
import { handleHttpCode, journeyTypes, messageType } from 'assets/constants';

export function useBookAppointment({ hasRecaptcha, isPreview, userData, warningText, buttonAnotherSlot, dateAndTimeStepPosition, journeyTypeId }) {

  const api = useOnlineBookingApi();
  const setAppointmentRequest = journeyTypeId === journeyTypes.journey
    ? api.appointment.useSetAppointmentRegular()
    : api.appointment.useSetAppointmentReschedule()

  const popupState = useSelector(({ current }) => current.general.popupState)
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (popupState.open) {
      const popupProps = {
        button: buttonAnotherSlot,
      }
      popupProps['message'] = warningText;
      dispatch(popupActiveSet({ ...popupState, ...popupProps }));
    }
  }, [buttonAnotherSlot])

  if (isPreview)
    return async () => { dispatch(successStepSet(true)); dispatch(appointmentDataSet({ appointmentId: -1 })) };

  return async () => {

    const { dateAndTime, service, location } = userData;
    const { serviceIds, date, appointmentStartTime } = dateAndTime;
    const serviceIdsFromApi = userData.clientStateData?.selectedSlot &&  Object.values(userData.clientStateData?.selectedSlot)[0].serviceIds
    const dateFromApi = userData.clientStateData?.selectedSlot &&  Object.values(userData.clientStateData?.selectedSlot)[0].date
    const appointmentStartTimeFromApi = userData.clientStateData?.selectedSlot && Object.keys(userData.clientStateData?.selectedSlot)[0]

    const questions = Object.keys(userData)
      .filter((val) => !val.includes('after_property_questions_'))
      .filter((val) => val.includes('questions_'))
      .reduce((obj, val) => Object.assign(obj, userData[val]), {});

    const req = { serviceIds: serviceIdsFromApi || serviceIds, date: dateFromApi || date, questionAnswerDict: questions, appointmentStartTime: parseInt(appointmentStartTimeFromApi || appointmentStartTime), hasRecaptcha };

    if (!!dateAndTime?.appointmentTypeId) req.appointmentTypeId = dateAndTime?.appointmentTypeId;

    setAppointmentRequest.mutateAsync(req)
      .then((res) => {
        dispatch(successStepSet(true));
        dispatch(appointmentDataSet(res));
        dispatch(userDataSet({ processGUID: res.processGuid, service: { name: res.serviceName }, location: { ...location, name: res.unitName } }))
        if (res?.scriptMessages?.length > 0)
          dispatch(scriptMessagesSet(res.scriptMessages));

      })
      .catch((error) => {
        if (!error) return;
        if (error?.status === 401) return;

        const scriptMessages = error?.scriptMessages || [];
        if (scriptMessages?.length > 0) {
          dispatch(scriptMessagesSet(error?.scriptMessages));
          return;
        }

        if (error.errorCode === handleHttpCode.slot_locked || error.errorCode === handleHttpCode.no_free_slots) {
          dispatch(popupActiveSet({
            open: true,
            icon: 'IconSad',
            message: warningText,
            button: buttonAnotherSlot,
            goToStepOnClose: dateAndTimeStepPosition
          }));
          return;
        }

        //show error message from the server when its not script or slot locked
        dispatch(scriptMessagesSet([{ messageType: messageType.error, message: error?.errorMessage }]));
      })
  }

}
